import React, {createContext, useContext, useEffect, useState} from "react";
import decode from "jwt-decode";
import axios from "axios";
import config from "../config/config";

export const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const getToken = () => localStorage.getItem('access_token');

    const isTokenExpired = (token) => {
        try {
            const decoded = decode(token);
            const expired = decoded.exp < Date.now() / 1000;
            if (expired) {
                localStorage.removeItem('courseTest');
            }
            return expired; // Checking if token is expired. N
        } catch (err) {
            return false;
        }
    }

    const isAccessTokenExists = () => {
        // check if token is valid
        const access_token = getToken();
        return !!access_token;

    }

    const [isLoggedIn, setIsLoggedIn] = useState(isAccessTokenExists());

    useEffect(() => {
        const renewAccessTokenIfNeeded = async () => {
            if (isAccessTokenExists()) {
                setIsLoggedIn(true);
                if (isTokenExpired(getToken())) {
                    await renewToken();
                }
            } else {
                logout();
            }
        };

        renewAccessTokenIfNeeded();
    }, []);

    const login = (accessToken, refreshToken) => {
        localStorage.setItem('access_token', accessToken);
        if (refreshToken) {
            localStorage.setItem('refresh_token', refreshToken);
        }
        setIsLoggedIn(true);
    };

    const logout = () => {
        localStorage.clear();
        setIsLoggedIn(false);
    };

    const renewToken = async () => {
        const refreshToken = localStorage.getItem('refresh_token');

        // send refresh token to server and get a new access token
        try {
            const response = await axios.post(config.apiRouteMap.renewToken.url, {refreshToken});
            const newAccessToken = response.data.accessToken;

            // save new access token in local storage
            localStorage.setItem('access_token', newAccessToken);
            return newAccessToken;
        } catch (error) {
            console.error("Failed to renew access token: ", error);
            logout();
            return null;
        }
    };

    return (
        <AuthContext.Provider
            value={{isLoggedIn, login, logout, getToken, renewToken}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
